import { render, staticRenderFns } from "./SelfPublishingFlowQuoteFooterImprimerVosLivres.vue?vue&type=template&id=bee4b444&scoped=true&"
import script from "./SelfPublishingFlowQuoteFooterImprimerVosLivres.vue?vue&type=script&lang=js&"
export * from "./SelfPublishingFlowQuoteFooterImprimerVosLivres.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee4b444",
  null
  
)

export default component.exports